export default __webpack_public_path__ + "static/media/pvilla4-4.dbfd5e2f.jpg";